export default __webpack_public_path__ + "static/media/spinner-48.a2646a8b.gif";